import React, { useState, useEffect, useRef } from 'react';
import '../scss/Emsmain.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from '../components/header'
import BaseURL from '../assets/contants/BaseURL';
import * as THREE from 'three';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Chart from 'react-apexcharts';
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import axios from 'axios';
import moment from 'moment';
import ExcelJS from 'exceljs';



const monthNames = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
];

const FlowSub = () => {
    const location = useLocation();
    const { meterId, groupName } = location.state || {};
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState("Hourly");
    const [dateselectedDate, setdateSelectedDate] = useState(new Date());
    const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [hourlyfromdate, setHourlyfromdate] = useState(0);
    const [hourlytodate, setHourlytodate] = useState(0);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [selectedNewYear, setSelectedNewYear] = useState(new Date().getFullYear());
    const [flowYearData, setFlowYearData] = useState({
        selected_year: '',
        graph_title: '',
        x_axis_label: '',
        y_axis_label: '',
        bars: [],
        time_intervals: []
    });
    const [displayData, setDisplayData] = useState({
        meterName: '',
        meterId: '',
        status: 'Inactive',
        model: '',
        location: '',
        lastUpdated: '',
        totalFlow: 0,
        flowStatus: null,
        flowStatusLabel: '',
        flowDirection: null,
        flowDirectionLabel: '',
        installationDate: '',
        groupName: '',
        multiFactor: 1,
        adjusted_flow: '',
        unit_type: ''
    });

    const [flowData, setFlowData] = useState({
        today: { liters: 0 },
        yesterday: { liters: 0 },
        current_month: { liters: 0 },
        last_month: { liters: 0 }
    });

    const [hourlyloading, setHourlyLoading] = useState(false);
    const [hourlyData, setHourlyData] = useState([]);
    const [currenthourlyPage, setCurrenthourlyPage] = useState(1);
    const [totalLiters, setTotalLiters] = useState(0);
    const [dailyloading, setDailyLoading] = useState(false);
    const [dailyreportData, setDailyreportData] = useState([]);
    const [currentdailyreportPage, setCurrentdailyreportPage] = useState(1);
    const [totalDailyLiters, setTotalDailyLiters] = useState(0);
    const [monthlyloading, setMonthlyLoading] = useState(false);
    const [monthlyfromDate, setmonthlyFromDate] = useState(null);
    const [monthlytoDate, setmonthlyToDate] = useState(null);
    const [currentmonthlyreportPage, setCurrentmonthlyreportPage] = useState(1);
    const [monthsData, setMonthsData] = useState([]);
    const [reportData, setReportData] = useState(null);
    const [unitType, setUnitType] = useState('kilo');
    const [unitHourlyType, setUnitHourlyType] = useState('kilo');

    useEffect(() => {
        if (meterId) {
            fetchMeterDetails();
            fetchFlowData(meterId);
        }
    }, [meterId]);

    const fetchMeterDetails = async () => {
        try {
            const response = await axios.get(`${BaseURL}meters/flowmeters/`);
            const meter = response.data.find(m => m.flow_meter_id === meterId);
            
            if (meter) {
                setDisplayData(prev => ({
                    ...prev,
                    meterName: meter.flow_meter_name || 'N/A',
                    model: meter.model || 'N/A',
                    location: meter.location || 'N/A',
                    installationDate: meter.installation_date || 'N/A',
                    multiFactor: meter.multi_factor || 1
                }));
            }
        } catch (err) {
            console.error('Error fetching meter details:', err);
        }
    };

    const fetchFlowData = async (flowmeterId) => {
        const today = new Date();
        const indiaTime = new Date(today.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));
        const formattedDate = `${indiaTime.getFullYear()}-${(indiaTime.getMonth() + 1).toString().padStart(2, '0')}-${indiaTime.getDate().toString().padStart(2, '0')}`;
        
        try {

            const response = await axios.post(`${BaseURL}data/flowmeter-data/`, {
                flowmeter_id: flowmeterId,
                date: formattedDate
            });

            const adjustedFlowData = {
                today: { 
                    liters: (response.data.today?.liters || 0),
                    unit: response.data.today?.unit || 'liter'
                },
                yesterday: { 
                    liters: (response.data.yesterday?.liters || 0),
                    unit: response.data.yesterday?.unit || 'liter'
                },
                current_month: { 
                    liters: (response.data.current_month?.liters || 0),
                    unit: response.data.current_month?.unit || 'liter'
                },
                last_month: { 
                    liters: (response.data.last_month?.liters || 0),
                    unit: response.data.last_month?.unit || 'liter'
                }
            };

            setFlowData(adjustedFlowData);
        } catch (err) {
            console.error('Error fetching flow data:', err);
        }
    };

    const getDisplayUnit = (unit) => {
        switch (unit) {
            case 'kilo': return 'KL';
            case 'mega': return 'ML';
            default: return 'L';
        }
    };

    useEffect(() => {
        if (!meterId) return;

        const fetchData = async () => {
            const today = new Date();
            const indiaTime = new Date(today.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));
            const formattedDate = `${indiaTime.getFullYear()}-${(indiaTime.getMonth() + 1).toString().padStart(2, '0')}-${indiaTime.getDate().toString().padStart(2, '0')}`;
            
            try {

                const response = await axios.post(`${BaseURL}data/flow-data/`, {
                    meter_id: meterId,
                    date: formattedDate
                });

                const data = response.data.details;
                const adjustedTotalFlow = (data.total_flow || 0);

                setDisplayData({
                    meterName: data.meter_name || 'N/A',
                    meterId: data.meter_id || 'N/A',
                    status: data.status || 'Inactive',
                    model: data.model || 'N/A',
                    location: data.location || 'N/A',
                    lastUpdated: data.last_updated || 'N/A',
                    totalFlow: adjustedTotalFlow,
                    flowStatus: data.flow_status,
                    flowStatusLabel: data.flow_status_label || 'N/A',
                    flowDirection: data.flow_direction,
                    flowDirectionLabel: data.flow_direction_label || 'N/A',
                    installationDate: data.installation_date || 'N/A',
                    groupName: data.group_name || 'N/A',
                    adjusted_flow: data.adjusted_flow || 0,
                    unit_type: data.unit_type || 'L'
                });
            } catch (err) {
                console.log(err.response?.data?.error || "Failed to fetch data");
            }
        };

        fetchData();
    }, [meterId]);

    const flowDirection = displayData.flowDirection === 1 ? 'forward' : 'reverse';
    const flowStatus = displayData.flowStatusLabel || 'N/A';

    const getStatusStyle = (status) => {
        switch (status.toLowerCase()) {
            case 'flow zero':
                return { backgroundColor: '#f0ad4e', color: 'white' }; // orange
            case 'flow on':
                return { backgroundColor: '#5cb85c', color: 'white' }; // green
            case 'high flow':
                return { backgroundColor: '#0275d8', color: 'white' }; // blue
            case 'pipe empty':
                return { backgroundColor: '#d9534f', color: 'white' }; // red
            default:
                return { backgroundColor: '#777', color: 'white' }; // gray
        }
    };

    const getStatusColor = (status) => {
        if (status === 'Active') return 'green';
        if (status === 'Inactive') return 'red';
        return 'orange';
    };


    const handleNewDateChange = (date) => {
        setdateSelectedDate(date);
    };

    const handleMonthChange = (e) => setSelectedMonth(parseInt(e.target.value));
    const handleYearChange = (e) => setSelectedYear(parseInt(e.target.value));

    const [chartData, setChartData] = useState({
        selected_day: "",
        graph_title: "Hourly Water Consumption",
        x_axis_label: "Hours",
        y_axis_label: "Liters",
        bars: [
            {
                name: "liters",
                data: [],
            },
        ],
        time_intervals: [],
    });
    const [dailyData, setDailyData] = useState({
        categories: [],
        liters: [],
    });

    const tabs = ["Hourly", "Daily", "Monthly"];

    const handleTabChange = (tab) => {
        setActiveTab(tab);

        if (tab !== "Hourly") {
            setHourlyData([]);
            setHourlyfromdate(0);
            setHourlytodate(0);
            setCurrenthourlyPage(1);
            setTotalLiters(0);
        }
        if (tab !== "Daily") {
            setDailyreportData([]);
            setFromDate(0);
            setToDate(0);
            setCurrentdailyreportPage(1);
            setTotalDailyLiters(0);
        }
        if (tab !== "Monthly") {
            setMonthsData([]);
            setmonthlyFromDate(0);
            setmonthlyToDate(0);
            setCurrentmonthlyreportPage(1);
            setReportData(0);
        }
    };

    useEffect(() => {
        if (meterId) {
            fetchHourlyData(meterId, dateselectedDate);
        }
    }, [meterId, dateselectedDate]);

    const fetchHourlyData = async (flowmeterId, date) => {

        try {
            const formattedDate = date.toISOString().split('T')[0];

            const response = await axios.post(`${BaseURL}data/flow-hourly-consumption/`, {
                flowmeter_id: flowmeterId,
                date: formattedDate
            });

            const adjustedData = {
                ...response.data,
                unit: getDisplayUnit(response.data.unit_type),
                bars: response.data.bars.map(bar => ({
                    ...bar,
                    data: bar.data.map(value => value)
                }))
            };

            setChartData(adjustedData);
        } catch (err) {
            console.error('Error fetching hourly data:', err);

            setChartData({
                ...chartData,
                bars: [{ name: "liters", data: Array(24).fill(0) }],
                time_intervals: Array.from({ length: 24 }, (_, i) =>
                    `${i.toString().padStart(2, '0')}:00 to ${((i + 1) % 24).toString().padStart(2, '0')}:00`
                ),
                unit: 'L'
            });
        }
    };

    useEffect(() => {
        if (meterId) {
            fetchDailyConsumption();
        }
    }, [meterId, selectedMonth, selectedYear]);

    const fetchDailyConsumption = async () => {

        try {

            const response = await axios.post(`${BaseURL}data/flow-daily-consumption/`, {
                flowmeter_id: meterId,
                month: selectedMonth,
                year: selectedYear
            });

            const data = response.data.data.daily;
            const categories = Object.keys(data);
            const liters = Object.values(data).map(item => item[0]);

            setDailyData({
                categories,
                liters,
                unitType: response.data.unit_type
            });

        } catch (err) {
            console.error("Error fetching daily consumption:", err);
        }
    };

    useEffect(() => {
        if (meterId) {
            fetchFlowYearData(meterId, selectedNewYear);
        }
    }, [meterId, selectedNewYear]);

    const fetchFlowYearData = async (flowmeterId, year) => {
        try {

            const response = await axios.post(`${BaseURL}data/flow-monthly-consumption/`, {
                flowmeter_id: flowmeterId,
                year: year
            });
            const adjustedData = {
                ...response.data,
                bars: response.data.bars.map(bar => ({
                    ...bar,
                    data: bar.data.map(value => value)
                }))
            };

            setFlowYearData(adjustedData);
        } catch (err) {
            console.error('Error fetching flow data:', err);
        }
    };

    const handleNewYearChange = (e) => {
        const year = parseInt(e.target.value);
        setSelectedNewYear(year);
    };

    const chartDatas = {
        categories: monthNames,
        liters: flowYearData.time_intervals?.length > 0
            ? flowYearData.bars[0]?.data || Array(12).fill(0)
            : Array(12).fill(0)
    };


    const handleGetHourlyReport = async () => {
        if (!hourlyfromdate || !hourlytodate || !meterId) {
            alert("Please select both date range and ensure meter ID is available");
            return;
        }

        setHourlyLoading(true);
        try {

            const fromDate = moment(hourlyfromdate).format("YYYY-MM-DD");
            const fromTime = moment(hourlyfromdate).format("HH:mm");
            const toDate = moment(hourlytodate).format("YYYY-MM-DD");
            const toTime = moment(hourlytodate).format("HH:mm");

            const response = await axios.post(`${BaseURL}data/flow-hourly-report/`, {
                from_date: fromDate,
                to_date: toDate,
                from_time: fromTime,
                to_time: toTime,
                flowmeter_id: meterId
            });

            if (response.data.results) {
                const transformedData = response.data.results.time_intervals.map((time, index) => ({
                    id: index,
                    date: response.data.results.date[index],
                    timeInterval: time,
                    startLiters: response.data.results.columns[0].data[index] || 0,
                    endLiters: response.data.results.columns[1].data[index] || 0,
                    totalLiters: response.data.results.columns[2].data[index] || 0
                }));
                const adjustedTotalLiters = transformedData.reduce(
                    (sum, row) => sum + (row.totalLiters || 0),
                    0
                );

                setHourlyData(transformedData);
                setTotalLiters(adjustedTotalLiters);
                setUnitHourlyType(response.data.unit_type);
            } else if (response.data.error) {
                alert(response.data.error);
                setHourlyData([]);
                setTotalLiters(0);
            }
        } catch (error) {
            console.error("Error fetching hourly report:", error);
            alert("Failed to fetch hourly report data");
            setHourlyData([]);
            setTotalLiters(0);
        } finally {
            setHourlyLoading(false);
        }
    };

    const formatDateForDisplay = (dateString) => {
        return moment(dateString).format("YYYY-MM-DD");
    };

    const rowsPerPage = 10;

    const totalhourlyPages = Math.ceil(hourlyData.length / rowsPerPage);

    const indexOfLastRow = currenthourlyPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = hourlyData.slice(indexOfFirstRow, indexOfLastRow);

    const handlehourlyPageChange = (newPage) => {
        setCurrenthourlyPage(newPage);
    };

    const handleGetDailyReport = async () => {
        if (!fromDate || !toDate || !meterId) {
            alert("Please select both date range and ensure meter ID is available");
            return;
        }

        setDailyLoading(true);
        try {

            const startDate = moment(fromDate).format("YYYY-MM-DD");
            const startTime = moment(fromDate).format("HH:mm");
            const endDate = moment(toDate).format("YYYY-MM-DD");
            const endTime = moment(toDate).format("HH:mm");

            const response = await axios.post(`${BaseURL}data/flow-daily-report/`, {
                start_date: startDate,
                end_date: endDate,
                from_time: startTime,
                to_time: endTime,
                flowmeter_id: meterId
            });

            if (response.data.columns && response.data.columns.length > 0) {
                const transformedData = response.data.dates.map((date, index) => ({
                    id: index,
                    date: date,
                    timeRange: response.data.Times[index],
                    startLiters: response.data.columns[0].data[index],
                    endLiters: response.data.columns[1].data[index],
                    totalLiters: response.data.columns[2].data[index]
                }));

                const adjustedTotalLiters = transformedData.reduce(
                    (sum, row) => sum + (row.totalLiters || 0),
                    0
                );

                setDailyreportData(transformedData);
                setTotalDailyLiters(adjustedTotalLiters);
                setUnitType(response.data.unit_type);
            } else if (response.data.error) {
                alert(response.data.error);
                setDailyreportData([]);
                setTotalDailyLiters(0);
            }
        } catch (error) {
            console.error("Error fetching daily report:", error);
            alert("Failed to fetch daily report data");
            setDailyreportData([]);
            setTotalDailyLiters(0);
        } finally {
            setDailyLoading(false);
        }
    };

    const rowsdailyPerPage = 10;
    const totaldailyPages = Math.ceil(dailyreportData.length / rowsdailyPerPage);
    const indexOfdailyLastRow = currentdailyreportPage * rowsdailyPerPage;
    const indexOfdailyFirstRow = indexOfdailyLastRow - rowsdailyPerPage;
    const currentDailyRows = dailyreportData.slice(indexOfdailyFirstRow, indexOfdailyLastRow);

    const handledailyPageChange = (newPage) => {
        setCurrentdailyreportPage(newPage);
    };

    const fetchMonthlyReport = async () => {
        if (!monthlyfromDate || !monthlytoDate || !meterId) {
            alert("Please select both date range and ensure meter ID is available");
            return;
        }

        setMonthlyLoading(true);
        try {

            const fromMonthYear = `${monthlyfromDate.getFullYear()}-${(monthlyfromDate.getMonth() + 1).toString().padStart(2, '0')}`;
            const toMonthYear = `${monthlytoDate.getFullYear()}-${(monthlytoDate.getMonth() + 1).toString().padStart(2, '0')}`;

            const response = await axios.post(`${BaseURL}data/flow-monthly-report/`, {
                from_month_year: fromMonthYear,
                to_month_year: toMonthYear,
                flowmeter_id: meterId
            });

            const adjustedData = {
                ...response.data,
                columns: response.data.columns.map(column => ({
                    ...column,
                    data: column.data.map(value => value)
                })),
                total_liter_all_months: response.data.total_liter_all_months
            };

            setReportData(adjustedData);

            const transformedData = adjustedData.months.map((month, index) => ({
                id: index + 1,
                month: month,
                startFlow: adjustedData.columns[0].data[index],
                endFlow: adjustedData.columns[1].data[index],
                totalFlow: adjustedData.columns[2].data[index]
            }));
            
            setMonthsData(transformedData);
        } catch (error) {
            console.error("Error fetching monthly report:", error);
            alert("Failed to fetch monthly report data");
        } finally {
            setMonthlyLoading(false);
        }
    };

    const rowsmonthlyPerPage = 10;
    const totalmonthlyPages = Math.ceil(monthsData.length / rowsmonthlyPerPage);
    const indexOfmonthlyLastRow = currentmonthlyreportPage * rowsmonthlyPerPage;
    const indexOfmonthlyFirstRow = indexOfmonthlyLastRow - rowsmonthlyPerPage;
    const currentMonthlyRows = monthsData.slice(indexOfmonthlyFirstRow, indexOfmonthlyLastRow);

    const handlemonthlyPageChange = (newPage) => {
        setCurrentmonthlyreportPage(newPage);
    };

    const handleMonthlyFromMonthChange = (date) => {
        setmonthlyFromDate(date);
    };

    const handleMonthlyToMonthChange = (date) => {
        setmonthlyToDate(date);
    };

    const handleHourlyExportToExcel = async () => {
        const unitText = unitHourlyType === 'kilo' ? 'KL' : 'ML';
        const fromDateTime = new Date(hourlyfromdate);
        const toDateTime = new Date(hourlytodate);

        const formattedFromDate = fromDateTime.toISOString().split('T')[0];
        const formattedFromTime = fromDateTime.toTimeString().split(' ')[0].replace(/:/g, '-');
        const formattedToDate = toDateTime.toISOString().split('T')[0];
        const formattedToTime = toDateTime.toTimeString().split(' ')[0].replace(/:/g, '-');

        const fileName = `Hourly_Flow_Report_${formattedFromDate}_${formattedFromTime}_to_${formattedToDate}_${formattedToTime}.xlsx`;
        
        if (!hourlyData || hourlyData.length === 0) {
            alert("No data available to export.");
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Hourly Flow Report');

        for (let rowNum = 1; rowNum <= 3; rowNum++) {
            const row = worksheet.getRow(rowNum);
            for (let i = 1; i <= 5; i++) {
                row.getCell(i).fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFDDDDDD' },
                };
            }
        }

        try {
            const logoBase64 = await getBase64FromImageUrl('/brad.png');
            const logoId = workbook.addImage({
                base64: logoBase64,
                extension: 'png'
            });

            const centerCol = Math.floor(5 / 2) - 1;
            worksheet.addImage(logoId, {
                tl: { col: centerCol + 1, row: 0, colOff: 0, rowOff: 0 },
                br: { col: centerCol + 2, row: 3, colOff: 0, rowOff: 0 },
                editAs: 'oneCell'
            });

            worksheet.getRow(1).height = 30;
            worksheet.getRow(2).height = 30;
            worksheet.getRow(3).height = 30;
        } catch (error) {
            console.error('Error adding logo:', error);
        }

        const dateRow = worksheet.addRow([`From: ${moment(hourlyfromdate).format("YYYY-MM-DD HH:mm")} To: ${moment(hourlytodate).format("YYYY-MM-DD HH:mm")}`]);
        worksheet.mergeCells(dateRow.number, 1, dateRow.number, 5);
        dateRow.font = { bold: true, size: 14 };
        dateRow.alignment = { horizontal: 'center' };
        dateRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD9EAD3' },
            };
        });

        const meterInfoRow = worksheet.addRow([
            `Flow Meter ID: ${meterId}`,
            '',
            `Group: ${groupName || 'N/A'}`,
            '',
            `Site: Coimbatore`
        ]);
        meterInfoRow.font = { bold: true };
        meterInfoRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFDDDDDD' },
            };
        });

        const titleRow = worksheet.addRow(['HOURLY FLOW REPORT']);
        titleRow.font = { bold: true, size: 16 };
        titleRow.alignment = { horizontal: 'center' };
        worksheet.mergeCells(titleRow.number, 1, titleRow.number, 5);
        titleRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FF1E90FF' },
            };
        });

        const headers = ['Date', 'Time Interval', 'Start Flow (Liters)', 'End Flow (Liters)', 'Total Flow (Liters)'];
        const headerRow = worksheet.addRow(headers);
        headerRow.font = { bold: true };
        headerRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFA500' },
            };
            cell.alignment = { horizontal: 'center' };
        });

        hourlyData.forEach((row, index) => {
            const dataRow = worksheet.addRow([
                row.date,
                row.timeInterval,
                `${row.startLiters} ${unitText}`,
                `${row.endLiters} ${unitText}`,
                `${row.totalLiters} ${unitText}`
            ]);

            dataRow.eachCell(cell => {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: index % 2 === 0 ? 'FFE8EAF6' : 'FFFFFFFF' },
                };
                cell.alignment = { horizontal: 'center' };
            });
        });

        const totalRow = worksheet.addRow([
            '', '', 'TOTAL', '', `${totalLiters.toFixed(2)}  ${unitText}`
        ]);
        totalRow.font = { bold: true };
        totalRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFEB3B' },
            };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
        });

        worksheet.columns = [
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 }
        ];

        workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob([buffer], { type: 'application/octet-stream' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            a.click();
            window.URL.revokeObjectURL(url);
        });
    };

    const handleDailyExportToExcel = async () => {
        const unitText = unitType === 'kilo' ? 'KL' : 'ML';
        if (!fromDate || !toDate || !meterId) {
            alert("Please select both date range and ensure meter ID is available");
            return;
        }

        if (!dailyreportData || dailyreportData.length === 0) {
            alert("No data available to export.");
            return;
        }

        const fromDateTime = new Date(fromDate);
        const toDateTime = new Date(toDate);

        const formattedFromDate = fromDateTime.toISOString().split('T')[0];
        const formattedFromTime = fromDateTime.toTimeString().split(' ')[0].replace(/:/g, '-');

        const formattedToDate = toDateTime.toISOString().split('T')[0];
        const formattedToTime = toDateTime.toTimeString().split(' ')[0].replace(/:/g, '-');

        const fileName = `Daily_Report_${formattedFromDate}_${formattedFromTime}_to_${formattedToDate}_${formattedToTime}.xlsx`;
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Daily Report');

        for (let rowNum = 1; rowNum <= 3; rowNum++) {
            const row = worksheet.getRow(rowNum);
            for (let i = 1; i <= 5; i++) {
                row.getCell(i).fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFDDDDDD' },
                };
            }
        }

        try {
            const logoBase64 = await getBase64FromImageUrl('/brad.png');
            const logoId = workbook.addImage({
                base64: logoBase64,
                extension: 'png'
            });

            const centerCol = Math.floor(5 / 2) - 1;

            worksheet.addImage(logoId, {
                tl: { col: centerCol + 1, row: 0, colOff: 0, rowOff: 0 },
                br: { col: centerCol + 2, row: 3, colOff: 0, rowOff: 0 },
                editAs: 'oneCell'
            });

            worksheet.getRow(1).height = 30;
            worksheet.getRow(2).height = 30;
            worksheet.getRow(3).height = 30;
        } catch (error) {
            console.error('Error adding logo:', error);
        }

        worksheet.getColumn(1).width = 20;
        worksheet.getColumn(2).width = 20;
        worksheet.getColumn(3).width = 20;
        worksheet.getColumn(4).width = 20;
        worksheet.getColumn(5).width = 20;

        const dateRow = worksheet.addRow([`From Date: ${moment(fromDate).format("YYYY-MM-DD HH:mm")}, To Date: ${moment(toDate).format("YYYY-MM-DD HH:mm")}`]);
        worksheet.mergeCells(dateRow.number, 1, dateRow.number, 5);
        dateRow.font = { bold: true, size: 14 };
        dateRow.alignment = { horizontal: 'center', vertical: 'middle' };
        dateRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD9EAD3' },
            };
        });

        const branchRow = worksheet.addRow(['Site: Coimbatore','',`Group: ${groupName || 'N/A'}`, '', `Meter ID: ${meterId}`]);
        branchRow.font = { bold: true, size: 12 };
        branchRow.getCell(1).alignment = { horizontal: 'left' };
        branchRow.getCell(3).alignment = { horizontal: 'center' };
        branchRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFDDDDDD' },
            };
        });

        const titleRow = worksheet.addRow(['Daily Report']);
        titleRow.font = { bold: true, size: 16 };
        titleRow.alignment = { horizontal: 'center' };
        worksheet.mergeCells(titleRow.number, 1, titleRow.number, 5);
        titleRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FF1E90FF' },
            };
        });

        const headers = ['Date', 'Time Range', 'Start Flow', 'End Flow', 'Total Flow'];
        const headerRow = worksheet.addRow(headers);
        headerRow.font = { bold: true };
        headerRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFA500' },
            };
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
        });

        dailyreportData.forEach((row, index) => {
            const dataRow = worksheet.addRow([
                formatDateForDisplay(row.date),
                row.timeRange,
                `${row.startLiters} ${unitText}`,
                `${row.endLiters} ${unitText}`,
                `${row.totalLiters} ${unitText}`
            ]);

            dataRow.eachCell(cell => {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: index % 2 === 0 ? 'FFE8EAF6' : 'FFFFFFFF' },
                };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
            });
        });

        const totalRow = worksheet.addRow(['', '', '', 'TOTAL', `${totalDailyLiters}  ${unitText}`]);
        totalRow.font = { bold: true };
        totalRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFEB3B' },
            };
            cell.alignment = { horizontal: 'right' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
        });

        workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob([buffer], { type: 'application/octet-stream' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            a.click();
            window.URL.revokeObjectURL(url);
        });
    };

    const handleMonthlyExportToExcel = async () => {
        const unitText = reportData?.unit_type === 'kilo' ? 'KL' : 'ML';
        if (!monthlyfromDate || !monthlytoDate || !meterId) {
            alert("Please select both date range and ensure meter ID is available");
            return;
        }

        if (!monthsData || monthsData.length === 0) {
            alert("No data available to export.");
            return;
        }

        const fromMonthYear = `${monthlyfromDate.getFullYear()}-${(monthlyfromDate.getMonth() + 1).toString().padStart(2, '0')}`;
        const toMonthYear = `${monthlytoDate.getFullYear()}-${(monthlytoDate.getMonth() + 1).toString().padStart(2, '0')}`;

        const fileName = `Monthly_Report_${fromMonthYear}_to_${toMonthYear}.xlsx`;
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Monthly Report');

        for (let rowNum = 1; rowNum <= 3; rowNum++) {
            const row = worksheet.getRow(rowNum);
            for (let i = 1; i <= 5; i++) {
                row.getCell(i).fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFDDDDDD' },
                };
            }
        }

        try {
            const logoBase64 = await getBase64FromImageUrl('/brad.png');
            const logoId = workbook.addImage({
                base64: logoBase64,
                extension: 'png'
            });

            const centerCol = Math.floor(5 / 2) - 1;

            worksheet.addImage(logoId, {
                tl: { col: centerCol + 1, row: 0, colOff: 0, rowOff: 0 },
                br: { col: centerCol + 2, row: 3, colOff: 0, rowOff: 0 },
                editAs: 'oneCell'
            });

            worksheet.getRow(1).height = 30;
            worksheet.getRow(2).height = 30;
            worksheet.getRow(3).height = 30;
        } catch (error) {
            console.error('Error adding logo:', error);
        }

        worksheet.getColumn(1).width = 10;
        worksheet.getColumn(2).width = 20;
        worksheet.getColumn(3).width = 20;
        worksheet.getColumn(4).width = 20;
        worksheet.getColumn(5).width = 20;

        const dateRangeText = `From Month: ${monthlyfromDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long' })} to ${monthlytoDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long' })}`;
        const dateRow = worksheet.addRow([dateRangeText]);
        worksheet.mergeCells(dateRow.number, 1, dateRow.number, 5);
        dateRow.font = { bold: true, size: 14 };
        dateRow.alignment = { horizontal: 'center', vertical: 'middle' };
        dateRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD9EAD3' },
            };
        });

        const branchRow = worksheet.addRow(['Site: Coimbatore','',`Group : ${groupName}`, '', `Meter ID: ${meterId}`]);
        branchRow.font = { bold: true, size: 12 };
        branchRow.getCell(1).alignment = { horizontal: 'left' };
        branchRow.getCell(3).alignment = { horizontal: 'center' };
        branchRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFDDDDDD' },
            };
        });

        const titleRow = worksheet.addRow(['Monthly Report']);
        titleRow.font = { bold: true, size: 16 };
        titleRow.alignment = { horizontal: 'center' };
        worksheet.mergeCells(titleRow.number, 1, titleRow.number, 5);
        titleRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FF1E90FF' },
            };
        });

        const headers = ['S.No', 'Month', 'Start Flow', 'End Flow', 'Total Flow'];
        const headerRow = worksheet.addRow(headers);
        headerRow.font = { bold: true };
        headerRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFA500' },
            };
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
        });

        monthsData.forEach((row, index) => {
            const dataRow = worksheet.addRow([
                row.id,
                row.month,
                `${row.startFlow.toFixed(2)} ${unitText}`,
                `${row.endFlow.toFixed(2)} ${unitText}`,
                `${row.totalFlow.toFixed(2)} ${unitText}`
            ]);

            dataRow.eachCell(cell => {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: index % 2 === 0 ? 'FFE8EAF6' : 'FFFFFFFF' },
                };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
            });
        });

        const totalRow = worksheet.addRow(['', '', '', 'TOTAL', `${(currentMonthlyRows.reduce((sum, row) => sum + row.totalFlow, 0) || 0).toFixed(2)} ${unitText}`]);
        totalRow.font = { bold: true };
        totalRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFEB3B' },
            };
            cell.alignment = { horizontal: 'right' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
        });

        workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob([buffer], { type: 'application/octet-stream' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            a.click();
            window.URL.revokeObjectURL(url);
        });
    };

const getBase64FromImageUrl = async (url) => {
    const response = await fetch(url);
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result.split(',')[1]);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
};

    const FlowMeterAnimation = ({ currentLiters, unit_type }) => {
        return (
            <div style={{ margin: '20px 0' }}>
                <svg
                    width="200"
                    height="200"
                    viewBox="0 0 300 210"
                    preserveAspectRatio="xMidYMid meet"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    {/* Define the clip path for the tank */}
                    <defs>
                        <clipPath id="tankClip">
                            <rect x="97.5" y="157.5" width="105" height="60" rx="7.5" ry="7.5" />
                        </clipPath>
                        
                        <linearGradient id="pipeGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                            <stop offset="0%" stopColor="white" stopOpacity="0.3" />
                            <stop offset="100%" stopColor="white" stopOpacity="0" />
                        </linearGradient>
                    </defs>

                    {/* Left pipe */}
                    <path d="M15 145 Q30 115 45 145 L45 235 Q30 265 15 235 Z" fill="#4a8bc9" stroke="#005a9e" strokeWidth="3" />
                    <rect x="45" y="145" width="30" height="90" fill="#4a8bc9" stroke="#005a9e" strokeWidth="3" />
                    <rect x="45" y="145" width="30" height="90" fill="url(#pipeGradient)" opacity="0.7" />
                    
                    {/* Right pipe */}
                    <path d="M285 145 Q270 115 255 145 L255 235 Q270 265 285 235 Z" fill="#4a8bc9" stroke="#005a9e" strokeWidth="3" />
                    <rect x="225" y="145" width="30" height="90" fill="#4a8bc9" stroke="#005a9e" strokeWidth="3" />
                    <rect x="225" y="145" width="30" height="90" fill="url(#pipeGradient)" opacity="0.7" />
                    
                    {/* Center tank */}
                    <rect x="75" y="135" width="150" height="105" rx="15" ry="15" fill="#4a8bc9" stroke="#005a9e" strokeWidth="4.5" />
                    <rect x="75" y="150" width="30" height="75" fill="#4a8bc9" />
                    <rect x="195" y="150" width="30" height="75" fill="#4a8bc9" />
                    <rect x="97.5" y="157.5" width="105" height="60" rx="7.5" ry="7.5" fill="#cce6ff" />
                    
                    {/* Pipe to meter */}
                    <rect x="125" y="37.5" width="50" height="105" fill="#4a8bc9" stroke="#005a9e" strokeWidth="3" rx="4.5" ry="4.5" />
                    <rect x="125" y="37.5" width="50" height="105" fill="url(#pipeGradient)" opacity="0.7" />
                    
                    {/* Meter */}
                    <circle cx="150" cy="30" r="70" fill="#d9d9d9" stroke="#777" strokeWidth="6" />
                    <circle cx="150" cy="30" r="55" fill="#a9d0f5" stroke="#555" strokeWidth="3" />
                    <rect x="104" y="15" width="92" height="35" rx="22.5" ry="22.5" fill="#ffffff" stroke="#777" strokeWidth="1" />
                    
                    {/* Current liters display */}
                    <text 
                        x="155" 
                        y="35" 
                        textAnchor="middle" 
                        dominantBaseline="middle" 
                        fill="#333" 
                        fontFamily="Arial" 
                        fontSize="14" 
                        fontWeight="bold"
                    >
                        {currentLiters.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})} {getDisplayUnit(unit_type)}
                    </text>

                    {/* Enhanced water flow animation - more lines with varied properties */}
                    <g clipPath="url(#tankClip)">
                        {Array.from({ length: 20 }).map((_, index) => {
                            const yPos = 158 + (index * 3);
                            const width = 10 + (Math.random() * 10);
                            const height = 2 + (Math.random() * 1.5);
                            const speed = 0.5 + (Math.random() * 0.7);
                            const delay = index * 0.05;
                            
                            return (
                                <rect
                                    key={index}
                                    x="45"
                                    y={yPos}
                                    width={width}
                                    height={height}
                                    fill="#0077ff"
                                    opacity={0.4 + (Math.random() * 0.4)}
                                    rx={height/2}
                                    ry={height/2}
                                >
                                    <animate
                                        attributeName="x"
                                        values={`45;202.5`}
                                        dur={`${speed}s`}
                                        repeatCount="indefinite"
                                        begin={`${delay}s`}
                                    />
                                    <animate
                                        attributeName="opacity"
                                        values={`${0.3 + (index * 0.02)};0.8;${0.3 + (index * 0.02)}`}
                                        dur={`${speed * 1.5}s`}
                                        repeatCount="indefinite"
                                        begin={`${delay}s`}
                                    />
                                </rect>
                            );
                        })}
                    </g>
                </svg>
            </div>
        );
    };

    return (
        <div className="dashboard-container">
            <Header title="BRADKEN WATER FLOW MANAGEMENT DASHBOARD" />

            <div className="card-container" style={{
                border: '1px solid #ccc',
                borderRadius: '10px',
                padding: '20px',
                boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                backgroundColor: '#fff',
                marginTop: '50px',
                maxWidth: '1000px',
                marginLeft: 'auto',
                marginRight: 'auto'
            }}>
                <h3 className="dashboard-subtitle">
                    <>
                        <span
                            onClick={() => navigate(-1)}
                            title={`Navigate to Main`}
                            style={{ color: '#007bff', cursor: 'pointer' }}
                        >
                            Flow Meter
                        </span>
                        {' / '}
                    </>

                    {/* <select
                        title="Change meters"
                        style={{
                            border: 'none',
                            fontWeight: 'bold',
                            fontSize: '16px',
                            cursor: 'pointer',
                            outline: 'none',
                            padding: '5px 10px',
                            position: 'relative',
                            color: '#007bff',
                            appearance: 'none',
                        }}
                    >
                        {meterId}
                    </select> */}
                    <>
                        <span>
                            {meterId}
                        </span>
                    </>
                </h3>
                <div className="widgets-container" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '20px', marginBottom: '20px' }}>
                    <div className="widget-container" style={{ width: '100%' }}>
                        <div className="widget" style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}>
                            <h3>Today's</h3>
                            <div style={{ display: 'table', width: '100%' }}>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', color: '#ffffff', paddingBottom: '15px' }}>Total Flow</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right' }}>{(flowData.today?.liters || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {getDisplayUnit(flowData.today?.unit)}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="widget-container" style={{ width: '100%' }}>
                        <div className="widget" style={{ padding: '10px', border: '1px solid #ccc', background: 'linear-gradient(145deg, #4caf50, #2b9e36)', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}>
                            <h3>Yesterday</h3>
                            <div style={{ display: 'table', width: '100%' }}>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', color: '#ffffff', paddingBottom: '15px' }}>Total Flow</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right' }}>{(flowData.yesterday?.liters || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {getDisplayUnit(flowData.yesterday?.unit)}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="widget-container" style={{ width: '100%' }}>
                        <div className="widget" style={{ padding: '10px', border: '1px solid #ccc', background: 'linear-gradient(145deg, #2196f3, #0b7dda)', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}>
                            <h3>Current Month</h3>
                            <div style={{ display: 'table', width: '100%' }}>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', color: '#ffffff', paddingBottom: '15px' }}>Total Flow</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right' }}>{(flowData.current_month?.liters || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {getDisplayUnit(flowData.current_month?.unit)}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="widget-container" style={{ width: '100%' }}>
                        <div className="widget" style={{ padding: '10px', border: '1px solid #ccc', background: 'linear-gradient(145deg, #ed76fd, #e53afd)', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}>
                            <h3>Last Month</h3>
                            <div style={{ display: 'table', width: '100%' }}>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', color: '#ffffff', paddingBottom: '15px' }}>Total Flow</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right' }}>{(flowData.last_month?.liters || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {getDisplayUnit(flowData.last_month?.unit)}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    className="extra-details-row"
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        gap: '20px',
                    }}
                >
                    <div
                        className="container-1"
                        style={{
                            flex: 1,
                            border: '1px solid #ccc',
                            borderRadius: '10px',
                            padding: '20px',
                            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                            backgroundColor: '#f9f9f9',
                        }}
                    >
                        <h4><strong>Details</strong></h4>
                        <table
                            style={{
                                width: '100%',
                                borderCollapse: 'collapse',
                                marginTop: '20px',
                                fontFamily: "'Roboto', sans-serif",
                                backgroundColor: '#fff',
                                boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                                borderRadius: '10px',
                                overflow: 'hidden',
                            }}
                        >
                            <tbody>
                                {[
                                    [
                                        { label: 'Flow Meter Name', value: displayData.meterName },
                                        { label: 'Flow Meter ID', value: displayData.meterId },
                                    ],
                                    [
                                        {
                                            label: 'Status',
                                            value: (
                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                    <div style={{
                                                        width: '80px',
                                                        height: '20px',
                                                        backgroundColor: getStatusColor(displayData.status),
                                                        borderRadius: '4px',
                                                        marginBottom: '5px',
                                                    }} />
                                                    <span>{displayData.status}</span>
                                                </div>
                                            ),
                                        },
                                        { label: 'Group Name', value: displayData.groupName },
                                    ],
                                    [
                                        { label: 'Model', value: displayData.model },
                                        { label: 'Last Updated', value: displayData.lastUpdated },
                                    ],
                                ].map((row, rowIndex) => (
                                    <tr key={rowIndex} style={{ borderBottom: '1px solid #ddd' }}>
                                        {row.map((item, cellIndex) => (
                                            <td key={`${rowIndex}-${cellIndex}`} style={{
                                                padding: '15px',
                                                width: '50%',
                                                backgroundColor: rowIndex % 2 === 0 ? '#f9f9f9' : '#fff',
                                                textAlign: 'center',
                                                verticalAlign: 'top',
                                                transition: 'background-color 0.3s ease',
                                            }}
                                                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#f0f8ff')}
                                                onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = rowIndex % 2 === 0 ? '#f9f9f9' : '#fff')}
                                            >
                                                <div style={{
                                                    fontWeight: 'bold',
                                                    marginBottom: '5px',
                                                    fontSize: '14px',
                                                    color: '#333',
                                                }}>
                                                    {item.label}
                                                </div>
                                                <div style={{
                                                    color: '#555',
                                                    fontSize: '13px',
                                                    wordWrap: 'break-word',
                                                }}>
                                                    {item.value}
                                                </div>
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                                <tr>
                                    <td colSpan="2" style={{
                                        padding: '15px',
                                        backgroundColor: '#f0f8ff',
                                        textAlign: 'center',
                                        fontWeight: 'bold',
                                        color: '#333',
                                        fontSize: '14px',
                                        borderTop: '1px solid #ddd',
                                    }}>
                                        <div>
                                            Current Flow:
                                            <span style={{ fontWeight: 'normal', marginLeft: '5px' }}>
                                                {displayData.adjusted_flow}  {getDisplayUnit(displayData.unit_type)}
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="container-2"
                        style={{
                            flex: 1,
                            border: '1px solid #ccc',
                            borderRadius: '10px',
                            padding: '20px',
                            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                            backgroundColor: '#f9f9f9',
                            position: 'relative',
                            overflow: 'hidden',
                        }}
                    >
                        <h4 style={{ marginBottom: '20px', textAlign: 'center' }}>Flow Meter</h4>
                        <FlowMeterAnimation 
                            currentLiters={displayData.adjusted_flow} 
                            unit_type={displayData.unit_type} 
                        />
                    </div>
                    <div className="container-2"
                        style={{
                            flex: 1,
                            border: '1px solid #ccc',
                            borderRadius: '10px',
                            padding: '20px',
                            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                            backgroundColor: '#f9f9f9',
                            position: 'relative',
                            overflow: 'hidden',
                        }}
                    >
                        <h4 style={{ marginBottom: '20px', textAlign: 'center' }}>Flow Status</h4>
                        <div
                            style={{
                                ...getStatusStyle(flowStatus),
                                display: 'inline-block',
                                textAlign: 'center',
                                padding: '10px 20px',
                                borderRadius: '999px',
                                marginTop: '90px',
                                fontSize: '1rem',
                                fontWeight: '600',
                                minWidth: '100px',
                            }}
                        >
                            {flowStatus.toUpperCase()}
                        </div>
                    </div>
                </div>
                <div className="charts-container" style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <div
                        className="container-4"
                        style={{
                            border: '1px solid #ccc',
                            borderRadius: '10px',
                            padding: '20px',
                            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                            backgroundColor: '#f9f0f3',
                            marginTop: '20px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%',
                        }}
                    >
                        <h4>Hourly Chart</h4>
                        <div style={{ marginBottom: "20px" }}>
                            <label
                                htmlFor="date-picker"
                                style={{
                                    flexDirection: "row",
                                    alignItems: "center",
                                    color: "#333",
                                    fontWeight: "bold",
                                    marginLeft: '40px',
                                    fontSize: "14px",
                                }}
                            >
                                Date:
                            </label>
                            <DatePicker
                                id="date-picker"
                                selected={dateselectedDate}
                                onChange={(date) => handleNewDateChange(date)}
                                dateFormat="yyyy/MM/dd"
                                customInput={
                                    <input
                                        style={{
                                            fontSize: "12px",
                                            width: '60%',
                                            padding: '5px',
                                            borderRadius: '5px',
                                            marginLeft: '-30px'
                                        }}
                                    />
                                }
                            />
                        </div>
                        <Chart
                            options={{
                                chart: {
                                    type: 'bar',
                                    height: 350,
                                    background: '#f9f0f3',
                                    toolbar: {
                                        tools: { download: false },
                                    },
                                },
                                plotOptions: {
                                    bar: {
                                        horizontal: false,
                                        columnWidth: '50%',
                                        endingShape: 'rounded',
                                    },
                                },
                                colors: ['#1a27db'],
                                dataLabels: {
                                    enabled: false,
                                },
                                xaxis: {
                                    categories: chartData.time_intervals,
                                    title: {
                                        text: chartData.x_axis_label,
                                    },
                                },
                                yaxis: {
                                    title: {
                                        text: chartData.unit,
                                    },
                                    labels: {
                                        formatter: (value) => {
                                            return new Intl.NumberFormat('en-US', {
                                                maximumFractionDigits: 2,
                                                minimumFractionDigits: 2
                                            }).format(value);
                                        },
                                    },
                                },
                                tooltip: {
                                    y: {
                                        formatter: (value) => {
                                            return `${new Intl.NumberFormat('en-US', {
                                                maximumFractionDigits: 2,
                                                minimumFractionDigits: 2
                                            }).format(value)} ${chartData.unit}`;
                                        },
                                    },
                                },
                                legend: {
                                    position: 'top',
                                    horizontalAlign: 'center',
                                    offsetX: 0,
                                    offsetY: 0,
                                },
                            }}
                            series={chartData.bars.map(bar => ({
                                name: bar.name,
                                data: bar.data,
                            }))}
                            type="bar"
                            height={350}
                            width={950}
                        />
                    </div>
                </div>
                <div
                    className="charts-container"
                    style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between', width: '100%' }}
                >
                    <div
                        className="container-4"
                        style={{
                            border: '1px solid #ccc',
                            borderRadius: '10px',
                            padding: '20px',
                            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                            backgroundColor: '#fbe9f6',
                            marginTop: '20px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%',
                        }}
                    >
                        <h4>Day's Consumption</h4>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                marginBottom: "30px",
                            }}
                        >
                            <label
                                style={{
                                    fontSize: "14px",
                                    color: "#333",
                                    fontWeight: "bold",
                                    marginRight: "10px",
                                }}
                            >
                                Month:
                            </label>
                            <select
                                value={selectedMonth}
                                onChange={handleMonthChange}
                                style={{
                                    padding: "5px",
                                    marginRight: "20px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                }}
                            >
                                {monthNames.map((month, index) => (
                                    <option key={index + 1} value={index + 1}>
                                        {month}
                                    </option>
                                ))}
                            </select>

                            <label
                                style={{
                                    fontSize: "14px",
                                    color: "#333",
                                    fontWeight: "bold",
                                    marginRight: "10px",
                                }}
                            >
                                Year:
                            </label>
                            <select
                                value={selectedYear}
                                onChange={handleYearChange}
                                style={{
                                    padding: "5px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                }}
                            >
                                {Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i).map(year => (
                                    <option key={year} value={year}>
                                        {year}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <Chart
                            options={{
                                chart: {
                                    type: 'bar',
                                    height: 350,
                                    background: '#fbe9f6',
                                    toolbar: {
                                        tools: {
                                            zoom: false,
                                            zoomin: false,
                                            zoomout: false,
                                            pan: false,
                                            reset: false,
                                            download: false,
                                        },
                                    },
                                    zoom: {
                                        enabled: true,
                                    },
                                },
                                plotOptions: {
                                    bar: {
                                        horizontal: false,
                                        columnWidth: '50%',
                                        endingShape: 'rounded',
                                    },
                                },
                                colors: ['#ff47f0', '#3743e6', '#00ced1'],
                                dataLabels: {
                                    enabled: false,
                                },
                                xaxis: {
                                    categories: dailyData.categories,
                                    title: {
                                        text: 'Dates',
                                    },
                                },
                                yaxis: {
                                    title: {
                                        text: chartData.unit,
                                    },
                                    labels: {
                                        formatter: (value) => {
                                            return new Intl.NumberFormat('en-US', {
                                                maximumFractionDigits: 2,
                                                minimumFractionDigits: 2
                                            }).format(value);
                                        },
                                    },
                                },
                                legend: {
                                    position: 'top',
                                    horizontalAlign: 'center',
                                    offsetX: 0,
                                    offsetY: 0,
                                },
                                tooltip: {
                                    y: {
                                        formatter: function (value) {
                                            const unit = dailyData.unitType === 'kilo' ? 'KL' : 
                                                    dailyData.unitType === 'mega' ? 'ML' : 'L';
                                            
                                            return `${value.toLocaleString(undefined, { 
                                                minimumFractionDigits: 2, 
                                                maximumFractionDigits: 2 
                                            })} ${unit}`;
                                        },
                                    },
                                },
                            }}
                            series={[
                                {
                                    name: 'liters',
                                    data: dailyData.liters,
                                }
                            ]}
                            type="bar"
                            height={350}
                            width={950}
                        />
                    </div>
                </div>
                <div className="charts-container" style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <div
                        className="container-4"
                        style={{
                            border: '1px solid #ccc',
                            borderRadius: '10px',
                            padding: '20px',
                            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                            backgroundColor: '#f0fbff',
                            marginTop: '20px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%',
                        }}
                    >
                        <h4>Monthly Consumption</h4>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                marginBottom: "30px",
                            }}
                        >
                            <label
                                style={{
                                    fontSize: "14px",
                                    color: "#333",
                                    fontWeight: "bold",
                                    marginRight: "10px",
                                }}
                            >
                                Year:
                            </label>
                            <select
                                value={selectedNewYear}
                                onChange={handleNewYearChange}
                                style={{
                                    padding: "5px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                }}
                            >
                                {Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i).map(year => (
                                    <option key={year} value={year}>
                                        {year}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <Chart
                            options={{
                                chart: {
                                    type: 'bar',
                                    height: 350,
                                    backgroundColor: '#f0fbff',
                                    toolbar: {
                                        tools: {
                                            zoom: false,
                                            zoomin: false,
                                            zoomout: false,
                                            pan: false,
                                            reset: false,
                                            download: false,
                                        },
                                    },
                                },
                                plotOptions: {
                                    bar: {
                                        horizontal: false,
                                        columnWidth: '50%',
                                        endingShape: 'rounded',
                                    },
                                },
                                colors: ['#3743e6'],
                                dataLabels: {
                                    enabled: false,
                                },
                                xaxis: {
                                    categories: chartDatas.categories,
                                    title: {
                                        text: flowYearData.x_axis_label || 'Month',
                                    },
                                },
                                yaxis: {
                                    title: {
                                        text: chartData.unit,
                                    },
                                    labels: {
                                        formatter: (value) => {
                                            return new Intl.NumberFormat('en-US', {
                                                maximumFractionDigits: 2,
                                                minimumFractionDigits: 2
                                            }).format(value);
                                        },
                                    },
                                },
                                tooltip: {
                                    y: {
                                        formatter: function (value) {
                                            const unit = getDisplayUnit(flowYearData.unit_type);
                                            return `${value.toLocaleString(undefined, { 
                                                minimumFractionDigits: 2, 
                                                maximumFractionDigits: 2 
                                            })} ${unit}`;
                                        },
                                    },
                                },
                            }}
                            series={[{
                                name: 'liters',
                                data: chartDatas.liters
                            }]}
                            type="bar"
                            height={350}
                            width={950}
                        />
                    </div>
                </div>
                <div className="dashboard">
                    <div className="main-container">
                        <h4>Reports</h4>
                        <div className="nav-bar">
                            {tabs.map((tab) => (
                                <button
                                    key={tab}
                                    className={activeTab === tab ? "active" : ""}
                                    onClick={() => handleTabChange(tab)}
                                >
                                    {tab}
                                </button>
                            ))}
                        </div>
                        {activeTab === "Hourly" && (
                            <div className="hourly-report">
                                <div className="card controls-card">
                                    <Datetime
                                        value={hourlyfromdate ? new Date(hourlyfromdate) : null}
                                        onChange={(momentObj) => {
                                            if (momentObj.isValid()) {
                                                setHourlyfromdate(momentObj.format("YYYY-MM-DDTHH:mm"));
                                            }
                                        }}
                                        inputProps={{
                                            placeholder: "Select From Date Time",
                                            style: { borderRadius: "10px", border: "1px solid #007bff", padding: "10px", width: "80%" }
                                        }}
                                        dateFormat="YYYY-MM-DD"
                                        timeFormat="HH:mm"
                                        closeOnSelect={false}
                                    />

                                    <Datetime
                                        value={hourlytodate ? new Date(hourlytodate) : null}
                                        onChange={(momentObj) => {
                                            if (momentObj.isValid()) {
                                                if (momentObj.hours() === 0 && momentObj.minutes() === 0) {
                                                    momentObj.set({
                                                        hour: 23,
                                                        minute: 59
                                                    });
                                                }
                                                setHourlytodate(momentObj.format("YYYY-MM-DDTHH:mm"));
                                            }
                                        }}
                                        inputProps={{
                                            placeholder: "Select To Date Time",
                                            style: { borderRadius: "10px", border: "1px solid #007bff", padding: "10px", width: "80%" }
                                        }}
                                        dateFormat="YYYY-MM-DD"
                                        timeFormat="HH:mm"
                                        closeOnSelect={false}
                                    />
                                    <button onClick={handleGetHourlyReport}>Get Report</button>
                                    <button onClick={() => handleHourlyExportToExcel('Hourly_Report.xlsx')}>
                                        <i className="excel-icon">📊</i> Excel
                                    </button>
                                </div>
                                {hourlyloading ? (
                                    <span className="spinner" />
                                ) : (
                                <div className="table-container">
                                    <h4 className="table-title">
                                        Hourly Log View from {hourlyfromdate ? moment(hourlyfromdate).format("YYYY-MM-DD HH:mm") : "Selected from Date"} 
                                        to {hourlytodate ? moment(hourlytodate).format("YYYY-MM-DD HH:mm") : "Selected to date"}
                                    </h4>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Date</th>
                                                <th>Hour</th>
                                                <th>Start Flow</th>
                                                <th>End Flow</th>
                                                <th>Total Flow</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {hourlyData.length > 0 ? (
                                                currentRows.map((row, index) => (
                                                    <tr key={row.id}>
                                                        <td>{formatDateForDisplay(row.date)}</td>
                                                        <td>{row.timeInterval}</td>
                                                        <td>{row.startLiters?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0.00'}   {unitHourlyType === 'kilo' ? 'KL' : 'ML'}</td>
                                                        <td>{row.endLiters?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0.00'}   {unitHourlyType === 'kilo' ? 'KL' : 'ML'}</td>
                                                        <td>{row.totalLiters?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0.00'}   {unitHourlyType === 'kilo' ? 'KL' : 'ML'}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                            <tr>
                                                <td colSpan="5" style={{ textAlign: "center" }}>
                                                    No Data Available
                                                </td>
                                            </tr>
                                            )}
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td colSpan="4" style={{ textAlign: "right" }}>TOTAL</td>
                                                <td>{(totalLiters || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}  {unitHourlyType === 'kilo' ? 'KL' : 'ML'}</td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                                )}

                                {hourlyData.length > 0 && (
                                    <div className="pagination-controls">
                                        <button
                                            disabled={currenthourlyPage === 1}
                                            onClick={() => handlehourlyPageChange(currenthourlyPage - 1)}
                                        >
                                            Previous
                                        </button>
                                        <span> {currenthourlyPage} of {totalhourlyPages}</span>
                                        <button
                                            disabled={currenthourlyPage === totalhourlyPages}
                                            onClick={() => handlehourlyPageChange(currenthourlyPage + 1)}
                                        >
                                            Next
                                        </button>
                                    </div>
                                )}
                            </div>
                        )}
                        {activeTab === "Daily" && (
                            <div className="daily-report">
                                <div className="card controls-card">
                                    <Datetime
                                        value={fromDate ? new Date(fromDate) : null}
                                        onChange={(momentObj) => {
                                            if (momentObj.isValid()) {
                                                setFromDate(momentObj.format("YYYY-MM-DDTHH:mm"));
                                            }
                                        }}
                                        inputProps={{
                                            placeholder: "Select From Date Time",
                                            style: { borderRadius: "10px", border: "1px solid #007bff", padding: "10px", width: "80%" }
                                        }}
                                        dateFormat="YYYY-MM-DD"
                                        timeFormat="HH:mm"
                                        closeOnSelect={false}
                                    />
                                    <Datetime
                                        value={toDate ? new Date(toDate) : null}
                                        onChange={(momentObj) => {
                                            if (momentObj.isValid()) {
                                                if (momentObj.hours() === 0 && momentObj.minutes() === 0) {
                                                    momentObj.set({
                                                        hour: 23,
                                                        minute: 59
                                                    });
                                                }
                                                setToDate(momentObj.format("YYYY-MM-DDTHH:mm"));
                                            }
                                        }}
                                        inputProps={{
                                            placeholder: "Select To Date Time",
                                            style: { borderRadius: "10px", border: "1px solid #007bff", padding: "10px", width: "80%" }
                                        }}
                                        dateFormat="YYYY-MM-DD"
                                        timeFormat="HH:mm"
                                        closeOnSelect={false}
                                    />
                                    <button onClick={handleGetDailyReport}>Get Report</button>
                                    <button onClick={() => {
                                            const fileName = `Daily_Report_${fromDate}_to_${toDate}.xlsx`;
                                            handleDailyExportToExcel(dailyreportData, fileName);
                                        }}
                                    >
                                        <i className="excel-icon">📊</i> Excel
                                    </button>
                                </div>
                                {dailyloading ? (
                                    <span className="spinner" />
                                ) : (
                                <div className="table-container">
                                    <h4 className="table-title">
                                        Daily Log View from {fromDate ? moment(fromDate).format("YYYY-MM-DD HH:mm") : "Selected from Date"} 
                                        to {toDate ? moment(toDate).format("YYYY-MM-DD HH:mm") : "Selected to date"}
                                    </h4>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Date</th>
                                                <th>time</th>
                                                <th>Start Flow</th>
                                                <th>End Flow</th>
                                                <th>Total Flow</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currentDailyRows.length > 0 ? (
                                                currentDailyRows.map((row) => (
                                                    <tr key={row.id}>
                                                        <td>{formatDateForDisplay(row.date)}</td>
                                                        <td>{row.timeRange}</td>
                                                        <td>{row.startLiters.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {unitType === 'kilo' ? 'KL' : 'ML'}</td>
                                                        <td>{row.endLiters.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {unitType === 'kilo' ? 'KL' : 'ML'}</td>
                                                        <td>{row.totalLiters.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {unitType === 'kilo' ? 'KL' : 'ML'}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                            <tr>
                                                <td colSpan="5" style={{ textAlign: "center" }}>
                                                    No Data Available
                                                </td>
                                            </tr>
                                            )}
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td colSpan="4" style={{ textAlign: "right" }}>TOTAL</td>
                                                <td>{totalDailyLiters.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {unitType === 'kilo' ? 'KL' : 'ML'}</td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                                )}
                                <div className="pagination-controls">
                                    <button
                                        disabled={currentdailyreportPage === 1 || currentDailyRows.length === 0}
                                        onClick={() => handledailyPageChange(currentdailyreportPage - 1)}
                                    >
                                        Previous
                                    </button>
                                    <span>  {currentdailyreportPage}   of   {totaldailyPages}  </span>
                                    <button
                                        disabled={currentdailyreportPage === totaldailyPages || currentDailyRows.length === 0}
                                        onClick={() => handledailyPageChange(currentdailyreportPage + 1)}
                                    >
                                        Next
                                    </button>
                                </div>
                            </div>
                        )}
                        {activeTab === "Monthly" && (
                            <div className="Monthly-Report">
                                <div className="card controls-card">
                                    <DatePicker
                                        selected={monthlyfromDate}
                                        onChange={handleMonthlyFromMonthChange}
                                        dateFormat="yyyy-MM"
                                        showMonthYearPicker
                                        placeholderText="Select From Month"
                                        className="custom-date-picker"
                                    />

                                    <DatePicker
                                        selected={monthlytoDate}
                                        onChange={handleMonthlyToMonthChange}
                                        dateFormat="yyyy-MM"
                                        showMonthYearPicker
                                        placeholderText="Select To Month"
                                        className="custom-date-picker"
                                    />
                                    <button onClick={fetchMonthlyReport}>Get Report</button>
                                    <button onClick={handleMonthlyExportToExcel}>
                                        <i className="excel-icon">📊</i> Excel
                                    </button>
                                </div>
                                    {monthlyloading ? (
                                        <div>
                                            <span className="spinner"></span>
                                        </div>
                                    ) : (
                                    <div className="table-container">
                                        <h4 className="table-title">Monthly Report from {monthlyfromDate ? monthlyfromDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long' }) : "Selected from Month"} to {monthlytoDate ? monthlytoDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long' }) : "Selected to Month"}</h4>
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>S.No</th>
                                                    <th>Month</th>
                                                    <th>Start Flow</th>
                                                    <th>End Flow</th>
                                                    <th>Total Flow</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {currentMonthlyRows.length > 0 ? (
                                                    currentMonthlyRows.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{item.id}</td>
                                                            <td>{item.month}</td>
                                                            <td>{item.startFlow.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {reportData?.unit_type === 'kilo' ? 'KL' : 'ML'}</td>
                                                            <td>{item.endFlow.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {reportData?.unit_type === 'kilo' ? 'KL' : 'ML'}</td>
                                                            <td>{item.totalFlow.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {reportData?.unit_type === 'kilo' ? 'KL' : 'ML'}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="5" style={{ textAlign: "center" }}>
                                                            No Data Available
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <td colSpan="4" style={{ textAlign: "right" }}>TOTAL</td>
                                                    <td>{currentMonthlyRows.reduce((sum, row) => sum + row.totalFlow, 0).toLocaleString(undefined, { 
                                                        minimumFractionDigits: 2, 
                                                        maximumFractionDigits: 2 
                                                    })} {reportData?.unit_type === 'kilo' ? 'KL' : 'ML'}</td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                    )}
                                <div className="pagination-controls">
                                    <button
                                        disabled={currentmonthlyreportPage === 1 || currentMonthlyRows.length === 0}
                                        onClick={() => handlemonthlyPageChange(currentmonthlyreportPage - 1)}
                                    >
                                        Previous
                                    </button>
                                    <span>  {currentmonthlyreportPage}   of   {totalmonthlyPages}  </span>
                                    <button
                                        disabled={currentmonthlyreportPage === totalmonthlyPages || currentMonthlyRows.length === 0}
                                        onClick={() => handlemonthlyPageChange(currentmonthlyreportPage + 1)}
                                    >
                                        Next
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FlowSub;
